<template>
  <v-container fluid>
    <form action @submit.prevent="submitForm">
      <div class="error" v-if="error">
        <p>{{ error }}</p>
      </div>

      <div class="field">
        <InputField
          v-model="form.childName"
          :labelTitle="$t('general.new-profile.form-baby')"
          type="text"
          required
          :placeholder="$t('general.new-profile.form-baby')"
          disabled
          margin="25px auto"
        ></InputField>

        <InputField
          v-model="form.name"
          :labelTitle="$t('general.new-profile.form-firstname-other')"
          type="text"
          required
          :placeholder="$t('general.new-profile.form-firstname-other')"
          margin="0 auto 25px auto"
        ></InputField>

        <InputField
          v-model="form.role"
          :labelTitle="$t('general.new-profile.form-role')"
          type="text"
          required
          :placeholder="$t('general.new-profile.form-role-placeholder')"
          margin="0 auto 25px auto"
        ></InputField>

        <div class="consent-checkbox"
             v-if="!$store.getters.user.hospital.useCuraeConsent">
          <label for="privacyConsent" class="checkbox-container">
            {{ $t("general.new-profile.consent-policy-1") }}
            <a
              href="https://leapstation.eu/neoparent/Neoparent-privacyverklaring.pdf"
              target="_blank"
              rel="noopener noreferrer"
              >{{ $t("general.new-profile.consent-policy") }}</a
            >.
            <input
              type="checkbox"
              id="privacyConsent"
              v-model="form.privacyConsent"
            />
            <span class="checkmark"></span>
          </label>
        </div>

        <LoadingButton v-if="loading" margin="0 auto 25px auto"></LoadingButton>
        <Button
          v-else
          type="submit"
          width="200"
          margin="0 auto 25px auto"
          :title="$t('general.new-profile.action-create')"
        ></Button>
      </div>
    </form>
  </v-container>
</template>

<script>

import {neoparentUsers} from "@/api";

export default {
  name: "neoparent-new-access",
  components: {},
  data() {
    return {
      error: "",
      passwordValid: true,
      confirmValid: true,
      form: {
        childName: this.$store.getters.user.patient.firstName,
        name: "",
        role: "",
        privacyConsent: false
      },
      loading: false
    };
  },
  mounted() {
  },
  methods: {
    async submitForm() {
      if (this.form.privacyConsent || this.$store.getters.user.hospital.useCuraeConsent) {
          this.loading = true;

          var data = {
            firstName: this.form.name,
            bio: this.form.role,
            nickName: this.form.name
          }

          await neoparentUsers.updateUserData(data)
            .then(() => {
              window.location = "/"
            });
        } else {
          this.error = this.$t("error.terms");
        }
    }
  }
};
</script>

<style scoped lang="scss"></style>
